import {Box, Button, Typography} from "@mui/material";
import Link from "next/link";
import styles from "./footer.module.css";
import clsx from "clsx";
import {JSX} from "react";
import SocialLinks from "~/app/components/social-links/SocialLinks";

export function Footer(): JSX.Element {
  const year = new Date().getFullYear();

  return (
      <footer className={clsx(styles.footer)} role="contentinfo">
        <Box className={styles.side} sx={{
          display: "flex",
          gap: 4,
          flexWrap: "wrap"
        }}>
          <SocialLinks variant={"ICONS_ONLY"} fontSize={"medium"} gap={0}/>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            ml: "auto",
          }}>
            <span className={styles.copy}>
              © IOV {year}
            </span>
            <Button component={Link} href="/contact" variant="text" size="small">
              Kontakt
            </Button>
            <Button component={Link} href="/imprint" variant="text" size="small">
              Impressum
            </Button>
          </Box>
        </Box>
        <hr/>
        <Box sx={{m: 1}}>
          <Typography variant="h6" component="h3" sx={{mt: 1, color: "#4a4a4a"}}>Klarstellung</Typography>
          <Typography variant="body2" sx={{color: "#4a4a4a"}}>
            Zur Internationalen Organisation Völkerrecht (IOV) gehören ausschließlich die auf dieser Website ausdrücklich genannten
            Funktionsträger.<br/>
            Die IOV ist nicht an finanziellen Modellen, Kryptowährungen, Vertriebsstrukturen, Schneeball- oder MLM-Systemen beteiligt und
            distanziert
            sich ausdrücklich von entsprechenden Angeboten oder Behauptungen Dritter.
          </Typography>
        </Box>
      </footer>
  );
}

export default Footer;
